module.exports = "<span *ngIf=\"!project.is_released && !isNone(project.deadline)\" [ngClass]=\"timeServ.isPast(project.deadline) ? 'text-danger' : 'font-bold'\">\n    {{timeServ.isLate(project.deadline)}}\n</span>\n<span *ngIf=\"!project.is_released && isNone(project.deadline)\">\n    {{timeServ.isLate(project.deadline)}}\n</span>"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/is-late/is-late.component.html
// module id = ../../../../../src/app/projects/shared/is-late/is-late.component.html
// module chunks = main